import { IFilter } from '../../types/filters';
import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { WithNeighborsContainer } from '../../containers/advancedFilters/WithNeighborsContainer';

export const withNeighbors: IFilter = {
  component: WithNeighborsContainer,
  availability: (jsonQuery, currentLocation, ctx) => {
    if (currentLocation === 'moscow_mo' || currentLocation === 'spb_lo') {
      return false;
    }
    const offerType = ctx.config.get<FOfferType>('neighbors.availableOfferType') || FOfferType.Any;

    return isAvailable(FDealType.Any, offerType)(jsonQuery) && currentLocation.hasNeighbors;
  },
};
